import DefaultHeader from "../../../shared/DefaultHeader";

const UserDashboard = () => {
  return (
    <>
      <DefaultHeader/>
      <div>Dashboard</div>
    </> 
);
};
export default UserDashboard;
